import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {IUser} from "@mangosoft/mango-login/lib/interfaces/auth.interface";
import {AuthService} from "@mangosoft/mango-login";
import {ActivityI, DamV1Config, TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";

@Component({
  selector: 'app-dam-v1',
  templateUrl: './dam-v1.component.html',
  styleUrls: ['./dam-v1.component.scss']
})
export class DamV1Component implements OnInit, OnChanges{

  @Input() task: TaskI | null = null;
  @Input() activity: ActivityI | null = null;

  taskStatus = TaskStatus;


  user: IUser | null = null;

  lang = "es";
  modeDam: 'write' | 'read' | 'view' = 'view';
  modeView: string = ""
  activeOpenModal: boolean = false;
  config!: DamV1Config

  constructor(
    private authService: AuthService
  ) {

  }

  ngOnInit() {



  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["task"]) {
      this.task = changes["task"]["currentValue"]
    }

    if (changes["activity"]) {
      this.activity = changes["activity"]["currentValue"]
    }

    // Read Dam Mode
    const changedTask: TaskI =  changes?.['task'].currentValue;
    this.modeDam = changedTask?.status?.key === this.taskStatus.draft ? this.activity?.damMode  || 'view' : 'read'

    this.user = this.authService.getDataToken();

    console.log("Activity => ",this.activity);
    console.log("User => ",this.user);
    // READ CONFIG PARAMETERS


    this.modeView = this.activity?.damModeView || 'list'
    this.config = {
      url: this.activity?.damV3Url || '',
      urlAccessControl: environment.accessControlAPI,
      idsModule: {
        pk: this.activity?.damModulePk || '',
        sk: this.activity?.damModuleSk || '',
      },
      secretbKey: environment.secretbKey,
      headersTable: this.activity?.damHeaders || [],
      tagsSearch: this.activity?.metadata?.tagsSearch || '',
      owner: this.user.username,
      optionsTags: this.activity?.damOptionTags || [],
      tagsFiles: (this.activity?.metadata?.tagsFiles || []).reduce((acc: any[], curr: any) => {
        if (curr?.value){
          acc.push(curr.value)
        }
        return acc;
      }, []),
      showSelectModeView: this.activity?.damShowSelectedView || false,
      mainTag: this.activity?.damMainTag || '',
      optionSearch: this.activity?.damOptionSearch || []
    }

    console.log("Mode View =>", this.modeView);
    console.log("Config => ", this.config);

    // Read Language
    this.lang = this.activity?.damLang || 'en'
  }


  openUploadModal(){
    this.activeOpenModal = true;
  }

  emiterActionUpload() {
    this.activeOpenModal = true;
  }

  emiterCloseModalUpload(){
    this.activeOpenModal=false
  }


}
